module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero7.png?5fe17d84";